/**
 * @file: 地址填写
 * @author: wence
 */
import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import {FormItem} from '../numberOptions/formCom';
import {validateRequire} from '../numberOptions/utils';
import {Modal} from 'antd-mobile';
import {flag, confirm} from './index';

import {updateContact} from '../../actions/activityAction';
import './index.less';

export default class FormModal extends PureComponent {
    static propTypes = {
        parizeInfo: PropType.object,
        visible: PropType.bool,
        onCancel: PropType.func,
        resetData: PropType.func,
        successMsg: PropType.string,
        aid: PropType.any
    }

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            address: '',
            mobile: ''
        };

        this.validate = {};
    }

    onSubmit = async () => {
        const parizeInfo = this.props.parizeInfo;
        const aid = this.props.aid;
        const params = {
            aid,
            flag,
            wid: parizeInfo && parizeInfo.wid,
            address: this.state.address.trim(),
            mobile: this.state.mobile.trim(),
            'user_name': this.state.name.trim()
        };

        const res = await updateContact(params);

        if (res.status === 0) {
            if (res.data.success) {
                this.confirm && this.confirm();
                this.confirm = confirm({
                    title: '',
                    content: this.props.successMsg,
                    okText: '确认',
                    isAnimation: false,
                    okClick: () => this.confirm && this.confirm()
                });
                this.props.resetData();
                this.setState({address: '', name: '', mobile: ''});
                this.props.onCancel();
            }
            else if (res.data && res.data.message) {
                this.confirm = confirm({
                    title: '提示',
                    isAnimation: false,
                    content: res.data.message,
                    okText: '确认',
                    okClick: () => this.confirm && this.confirm()
                });
            }
        }
        else {
            this.confirm && this.confirm();
            this.confirm = confirm({
                title: '提示',
                isAnimation: false,
                content: res && res.description,
                okText: '返回修改',
                okClick: () => {
                    this.confirm && this.confirm();
                }
            });
        }
    }

    pushValidate(key, node) {
        if (node) {
            this.validate[key] = node.validate;
        }
    }

    renderForm = () => {
        return (
            <div className="form">
                <FormItem
                    isRequire
                    ref={this.pushValidate.bind(this, 'name')}
                    value={this.state.name}
                    onChange={value => this.setState({name: value})}
                    label="姓名:"
                    rules={[validateRequire('姓名')]}
                    placeholder="请输入您的姓名"
                    type="input" />
                <FormItem
                    isRequire
                    label="地址:"
                    ref={this.pushValidate.bind(this, 'address')}
                    rules={[validateRequire('地址')]}
                    value={this.state.address}
                    onChange={value => this.setState({address: value})}
                    placeholder="请输入您的地址"
                    type="textarea" />
                <FormItem
                    isRequire
                    ref={this.pushValidate.bind(this, 'mobile')}
                    rules={[validateRequire('联系方式')]}
                    value={this.state.mobile}
                    onChange={value => this.setState({mobile: value})}
                    label="联系方式:"
                    placeholder="请输入您的联系方式"
                    type="input" />
            </div>
        );
    }
    render() {
        const {visible, onCancel} = this.props;
        return (
            <Modal
                transparent
                visible={visible}
                maskClosable
                onClose={onCancel}
                className="activity-form w-confirm-modal">
                <div onTouchStart={e => e.stopPropagation()} className="activity-form-container">
                    <div className="modal-title">
                        邮寄信息
                    </div>
                    <div className="scorll">
                        <div className="scorll-inner">
                            <p className="tips">1.活动结束后，统一安排发放，以快递方式邮寄至您填写的地址。</p>
                            <p className="tips">2.邮寄信息提交后不能修改，请您确认后提交</p>
                            {this.renderForm()}
                        </div>
                    </div>
                    <div className="x-footer">
                        <div onClick={onCancel} className="x-btn x-footer-cancel">
                            暂不提交
                        </div>
                        <div
                            onClick={() => {
                                let canSubmit = true;
                                Object.keys(this.validate).map(key => {
                                    const validate = this.validate[key] && this.validate[key]();

                                    if (validate.validate && canSubmit) {
                                        canSubmit = false;
                                    }
                                });
                                if (!canSubmit) {
                                    return;
                                }
                                this.confirm = confirm({
                                    title: '信息确认',
                                    content: '邮寄信息提交后不能修改，请您确认后提交',
                                    okText: '确认提交',
                                    isAnimation: false,
                                    okClick: this.onSubmit,
                                    cancelText: '去修改',
                                    cancelClick: () => this.confirm && this.confirm()
                                });
                            }}
                            className="x-btn x-footer-confirm">
                            确认提交
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/activity/modal.js